module.exports = __webpack_public_path__ + "static/media/other-doggos.ffa9f3ce.png";